// @flow strict

import * as React from 'react'
import {
  type NavigationItemProps,
  NavigationItem,
} from '../NavigationComponents/NavigationItem'
import NavigationWrapper from '../NavigationComponents/NavigationContainer'
import businessNavStyles from './BusinessNavigation.module.scss'
import businessNavListStyles from './BusinessNavigationList.module.scss'

import TrackEvents from '../../../atoms/TrackEvents/TrackEvents'
import BusinessButton from '../../../atoms/Button/BusinessButton'

const businessNavLinks: NavigationItemProps[] = [
  {
    href: '/i/business/features/',
    text: 'Features',
    label: '',
  },
  {
    href: '/i/business/testimonials/',
    text: 'Testimonials',
    label: '',
  },
  {
    href: '/i/business/eligibility/ ',
    text: 'Eligibility',
    label: '',
  },
  {
    href: '/i/business/help/',
    text: 'Get help',
    label: '',
  },
  {
    href: 'https://business.monzo.com/',
    text: 'Log in',
    label: '',
    openInNewTab: true,
  },
]

export default () => {
  return (
    <NavigationWrapper
      activeContext="business"
      logoHref="/i/business/"
      styles={businessNavStyles}
      navigationListStyles={businessNavListStyles}
      navLinks={businessNavLinks}
      callToAction={
        <TrackEvents category="conversion" action="download app" label="header">
          <BusinessButton
            href={'https://monzo.com/i/business/sign-up-for-business/'}
          >
            Sign up
          </BusinessButton>
        </TrackEvents>
      }
    >
      {businessNavLinks.map(props => (
        <NavigationItem
          {...props}
          key={props.text}
          navigationListStyles={businessNavListStyles}
        />
      ))}
    </NavigationWrapper>
  )
}
